// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topActions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 5px 15px 15px 30px;
  gap: 10px;
}

/* .tables{ */
/* overflow-y: auto; */
/* height: calc(100vh - 150px); */
/* } */
.routesmain {
  position: relative;
  top: 10px;
  left: 35px;
  width: calc(100vw - 35px);
}

.paddingButton {
  padding: 5px 10px 0px 30px;
}

.topActionshook {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 5px 0;
  margin-bottom: 10px;
}

.topActions h1 {
  margin: 0;
}

.topButtons {
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: space-between;
}

.subtop {
  display: flex;
  justify-content: space-between;
}

.allbuttons {
  display: flex;
  gap: 20px;
}

.topActionshook h1 {
  margin: 0;
  margin-left: 56px;
}

.circulardiv {
  border-radius: 50%;
  width: 40px;
  height: 40px;
  color: white;
  align-content: center;
  text-align: center;
}

.search-bar input {
  padding: 14px 5px 14px 5px;
  width: 265px;
  height: 33px;
}

.search-bar {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.search-bar button {
  height: 31px;
  width: 70px;
  margin-left: -70px;
  border: none;
  background-color: #1976d2;
  color: white;
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
}

.menu__box {
  display: none;
}

.addservicebutton button {
  height: 35px;
  display: flex;
  align-items: center;
  gap: 5px;
}`, "",{"version":3,"sources":["webpack://./routes/dashboard/details.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;EACA,SAAA;AACF;;AACA,aAAA;AACA,sBAAA;AACA,iCAAA;AACA,MAAA;AACA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;AAEF;;AAAA;EACE,0BAAA;AAGF;;AADA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAIF;;AADA;EACE,SAAA;AAIF;;AAFA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,8BAAA;AAKF;;AAHA;EACE,aAAA;EACA,8BAAA;AAMF;;AAJA;EACE,aAAA;EACA,SAAA;AAOF;;AALA;EACE,SAAA;EACA,iBAAA;AAQF;;AALA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;AAQF;;AALA;EACE,0BAAA;EACA,YAAA;EACA,YAAA;AAQF;;AANA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AASF;;AAPA;EACE,YAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAUF;;AARA;EACE,aAAA;AAWF;;AATA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AAYF","sourcesContent":[".topActions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  padding: 5px 15px 15px 30px;\n  gap: 10px;\n}\n/* .tables{ */\n/* overflow-y: auto; */\n/* height: calc(100vh - 150px); */\n/* } */\n.routesmain {\n  position: relative;\n  top: 10px;\n  left: 35px;\n  width: calc(100vw - 35px);\n}\n.paddingButton {\n  padding: 5px 10px 0px 30px;\n}\n.topActionshook {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n  padding: 5px 0;\n  margin-bottom: 10px;\n}\n\n.topActions h1 {\n  margin: 0;\n}\n.topButtons {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  justify-content: space-between;\n}\n.subtop {\n  display: flex;\n  justify-content: space-between;\n}\n.allbuttons {\n  display: flex;\n  gap: 20px;\n}\n.topActionshook h1 {\n  margin: 0;\n  margin-left: 56px;\n}\n\n.circulardiv {\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  color: white;\n  align-content: center;\n  text-align: center;\n}\n\n.search-bar input {\n  padding: 14px 5px 14px 5px;\n  width: 265px;\n  height: 33px;\n}\n.search-bar {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.search-bar button {\n  height: 31px;\n  width: 70px;\n  margin-left: -70px;\n  border: none;\n  background-color: #1976d2;\n  color: white;\n  cursor: pointer;\n  padding: 5px;\n  border-radius: 4px;\n}\n.menu__box {\n  display: none;\n}\n.addservicebutton button {\n  height: 35px;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
